module.exports = __webpack_public_path__ + "resources/img/zoom-ui-get-ready-screen.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-get-ready-screen.jpg
// module id = 1367
// module chunks = 0